const initialState = {
  SHOW_FOOTER: false,
  BLOCK_FOOTER: false,
  BLOCK_HEADER: false,
  CONTACT_FORM: {
    name: { value: "", error: false },
    email: { value: "", error: false },
    phone: { value: "", error: false },
    message: { value: "", error: false },
  },
  LANGUAGE: "ES",
  FULL_SCREEN_CARROUSEL: {
    images: [],
    label: "",
  },
};

const reducer = (state = initialState, action) => {
  console.log("reducer", state, action);
  switch (action.type) {
    case "CHANGE_LANGUAGE":
      return { ...state, LANGUAGE: action.payload };
    case "SHOW_FOOTER":
      return { ...state, SHOW_FOOTER: action.payload };
    case "BLOCK_FOOTER":
      return { ...state, BLOCK_FOOTER: action.payload };
    case "BLOCK_HEADER":
      return { ...state, BLOCK_HEADER: action.payload };
    case "CHANGE_CONTACT_INPUT":
      return { ...state, CONTACT_FORM: action.payload };
    case "SHOW_FULL_SCREEN_CARROUSEL":
      return { ...state, FULL_SCREEN_CARROUSEL: action.payload };
    default:
      return state;
  }
};

export default reducer;
